module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "walnut-haven-fluted-hayman-0.5dd89ea1.jpg";